import { localStorageProvider } from "../../../../AppController";

export const CircadiaEngineProviderFactory: ICircadiaEngineProviderFactory = ({
  circadia,
}) => {
  let gColor1 = "";
  let gColor2 = "";

  const windowCircadiaStatus = !!circadia;
  const isWindowCircadia = () => {
    return windowCircadiaStatus;
  };
  const isIOS = !!circadia && circadia.plat === "ios";

  if (!circadia) {
    circadia = {
      saveConfig: async (key: string, value: string) => {
        return true;
      },
      createSSPin: async (jwt: string, pin: string) => {
        return true;
      },
      changeSSPin: async (jwt: string, pin: string) => {
        return true;
      },
      saveSSValue: async (email: string, key: string, value: string) => {
        const storeValue = {
          email,
          key,
          value,
        };
        try {
          localStorageProvider.set("saveSSvalue", JSON.stringify(storeValue));
          return true;
        } catch (error) {
          return Promise.reject();
        }
      },
      loadSSValue: async (email: string, key: string, value: string) => {
        const storeValue = {
          email,
          key,
          value,
        };
        const getSSvalue = JSON.parse(
          localStorageProvider.get("saveSSvalue") || ""
        );
        return storeValue.value === getSSvalue.value ? true : Promise.reject();
      },
      cognitoProvidePin: async (pin: string) => {
        return true;
      },
      setStyleSheet: async (styes: string) => {
        return true;
      },
      setNotifTokenCb: (cb: (token: string) => void) => {
        const token = "dummy-token";
        cb(token);
        return undefined;
      },
      loadSSValueBio: async (email: string, key: string) => {
        return false;
      },
      loginIntercomUser: async (
        token: string,
        hmac: string,
        userInfo: {
          name: string;
          facility: string;
          user_id?: string;
          email?: string;
        }
      ) => {
        let response = null;
        if (isWindowCircadia()) {
          // TODO: remove then or await
          await circadia
            .loginIntercomUser(token, hmac, userInfo)
            .then((res: string) => {
              response = { code: "success", message: res };
            })
            .catch((err: { message: string }) => {
              response = { code: "error", message: err.message };
            });
        }
        return response;
      },
      logoutIntercomUser: async () => {
        let response = null;
        if (isWindowCircadia()) {
          // TODO: remove then or await
          await circadia
            .logoutIntercomUser()
            .then((res: string) => {
              response = { code: "success", message: res };
            })
            .catch((err: { message: string }) => {
              response = { code: "error", message: err.message };
            });
        }
        return response;
      },
      showIntercom: async () => {
        let response = null;
        if (circadia) {
          await circadia
            .showIntercom()
            .then((res: boolean) => {
              response = { code: "success", message: res };
            })
            .catch((err: { message: string }) => {
              response = { code: "error", message: err.message };
            });
        }
        return response;
      },
      hideIntercom: async () => {
        let response = null;
        if (isWindowCircadia()) {
          await circadia
            .hideIntercom()
            .then((res: boolean) => {
              response = { code: "success", message: res };
            })
            .catch((err: { message: string }) => {
              response = { code: "error", message: err.message };
            });
        }
        return response;
      },
      cognitoProvideMfa: (mfa: string) => {},
      cognitoUserLogout: () => {},
      setCognitoLoginFailedCb: (
        cb: (reason: { Code: string; Msg: string }) => void
      ) => {},
      setCognitoLoginDoneCb: (cb: () => void) => {},
      setCognitoMfaRequiredCb: (
        cb: (reason: {
          CODE_DELIVERY_DELIVERY_MEDIUM: string;
          CODE_DELIVERY_DESTINATION: string;
        }) => void
      ) => {},
      setCognitoPinRequiredCb: (cb: () => void) => {},
      cognitoTokens: async () => {
        return { AccessToken: "", IdToken: "" };
      },
      playSound: (sound: string) => {},
      cognitoUserLogin: (username: string, password: string) => {},
      cognitoProvideNewPassword: (password: string, attrs?: unknown) => {},
      setCognitoNewPasswordRequiredCb: (cb: (attrs: unknown) => void) => {},
      plat: "web",
      cognitoChangePassword: (
        accessToken: string,
        prevPassword: string,
        newPassword: string
      ) => {
        return { mdg: "", code: 0 };
      },
      intfv: -1,
    };
  }

  const playSound = async (sound: string) => {
    if (isWindowCircadia()) {
      return circadia.playSound(sound);
    }
    return true;
  };

  const getDeviceToken = async () =>
    new Promise<string>((resolve) => {
      if (!circadia) {
        return resolve("");
      }

      circadia.setNotifTokenCb((token) => resolve(token));
      return "";
    });

  const changeAppTopAndBottom = (color1: string, color2: string) => {
    if (color1 === gColor1 && color2 === gColor2) return;
    gColor1 = color1;
    gColor2 = color2;

    if (!circadia) {
      return;
    }
    circadia.setStyleSheet(
      `background-color:qlineargradient(spread:pad, x1:0, y1:0, x2:0, y2:1, stop:0.000 ${color1},stop:0.250 ${color1} ,stop:0.750 ${color2}, stop:1.000 ${color2});`
    );
  };

  const loginIntercomUser = async (
    token: string,
    hmac: string,
    userInfo: {
      name: string;
      facility: string;
      user_id?: string;
      email?: string;
    }
  ) => {
    let response = null;
    if (isWindowCircadia()) {
      await circadia
        .loginIntercomUser(token, hmac, userInfo)
        .then((res: string) => {
          response = { code: "success", message: res };
        })
        .catch((err: { message: string }) => {
          response = { code: "error", message: err.message };
        });
    }
    return response;
  };

  const logoutIntercomUser = async () => {
    let response = null;
    if (isWindowCircadia()) {
      await circadia
        .logoutIntercomUser()
        .then((res: string) => {
          response = { code: "success", message: res };
        })
        .catch((err: { message: string }) => {
          response = { code: "error", message: err.message };
        });
    }
    return response;
  };
  const showIntercom = async () => {
    let response = null;
    if (isWindowCircadia()) {
      await circadia
        .showIntercom()
        .then((res: boolean) => {
          response = { code: "success", message: res };
        })
        .catch((err: { message: string }) => {
          response = { code: "error", message: err.message };
        });
    }
    return response;
  };
  const hideIntercom = async () => {
    let response = null;
    if (isWindowCircadia()) {
      await circadia
        .hideIntercom()
        .then((res: boolean) => {
          response = { code: "success", message: res };
        })
        .catch((err: { message: string }) => {
          response = { code: "error", message: err.message };
        });
    }
    return response;
  };

  return {
    ...circadia,
    changeAppTopAndBottom,
    getDeviceToken,
    hideIntercom,
    showIntercom,
    logoutIntercomUser,
    loginIntercomUser,
    isWindowCircadia,
    playSound,
    isIOS,
  };
};
